<template>
  <div class="justify-content-center text-left dp02 p-3">
    <div class="col-lg-12">
      <b-button type="submit"
                class="myButton"
                @click="$router.go(-1)"
                style="float:left">
        {{ $t('common.Back') }}
      </b-button>
    </div>
    <div v-if="!ready"
         class="row mt-5">
      <b-spinner variant="primary"
                 type="grow"
                 label="Spinning" />
      <span>{{ $t('DataTable.Loading') }}...</span>
    </div>
    <div v-else
         class="row col-lg-12 mt-5">
      <div class="col-12">
        <h2>{{ email }}</h2>
      </div>
      <ValidationObserver ref="observer"
                          class="row col-12"
                          v-slot="{invalid}"
                          tag="form"
                          @submit.prevent="submit()">
        <div class="col-4">
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.street') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                name="street"
                rules="required"
                v-slot="{errors, classes}">
                <b-form-input
                  :class="{...classes, myInput: true}"
                  v-model="street" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.streetNumber') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                name="streetNumber"
                rules="required"
                v-slot="{errors, classes}">
                <b-form-input
                  :class="{...classes, myInput: true}"
                  v-model="streetNumber" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.city') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                name="city"
                rules="required"
                v-slot="{errors, classes}">
                <b-form-input
                  :class="{...classes, myInput: true}"
                  v-model="city" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </validationprovider>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.zipCode') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                name="zipCode"
                rules="required"
                v-slot="{errors, classes}">
                <b-form-input
                  :class="{...classes, myInput: true}"
                  v-model="zipCode" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.name') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                name="name"
                rules="required"
                v-slot="{errors, classes}">
                <b-form-input
                  :class="{...classes, myInput: true}"
                  v-model="name" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.surname') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                name="surname"
                rules="required"
                v-slot="{errors, classes}">
                <b-form-input
                  :class="{...classes, myInput: true}"
                  v-model="surname" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.gender') }}:</label>
            </div>
            <div class="col-lg-9">
              <GenderInput
                v-model="gender"
                :with-both="false" />
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.extID') }}:</label>
            </div>
            <div class="col-lg-9">
              <b-form-input
                class="myInput"
                :disabled="true"
                v-model="extID" />
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.openLimsID') }}:</label>
            </div>
            <div class="col-lg-9">
              <b-form-input
                class="myInput"
                :disabled="!isOpenLimsIDEditable"
                v-model="openLimsID" />
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-5">
              <label for="gender">{{ $t('fields.agreedToDataProcessing') }}:</label>
            </div>
            <div class="col-lg-4">
              <b-form-checkbox
                :disabled="true"
                v-model="agreedToDataProcessing"
                :value="true"
                :unchecked-value="false" />
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-5">
              <label for="gender">{{ $t('fields.agreedToTermsOfService') }}:</label>
            </div>
            <div class="col-lg-4">
              <b-form-checkbox
                :disabled="true"
                v-model="agreedToTermsOfService"
                :value="true"
                :unchecked-value="false" />
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.phone') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                name="phone"
                ref="phoneInput"
                rules="required"
                v-slot="{errors, classes}">
                <PhoneNumberInput
                  :editable="true"
                  v-model="phone" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="gender">{{ $t('fields.email') }}:</label>
            </div>
            <div class="col-lg-9">
              <ValidationProvider
                name="email"
                rules="required|email"
                v-slot="{errors, classes}">
                <b-form-input
                  :class="{...classes, myInput: true}"
                  v-model="email" />
                <p class="myInputError">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-3">
              <label for="registrationSource">{{ $t('fields.registrationSource') }}:</label>
            </div>
            <div class="col-lg-9">
              <b-form-input
                class="myInput"
                :disabled="true"
                :value="$t(registrationSource.value === 1 ? 'common.Client' : (registrationSource.value === 2 ? 'common.Administration' : 'common.Unknown'))" />
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-5">
              <label for="notifyByEmail"
                     v-b-tooltip.hover
                     :title="$t('notifications.email.ReservationNotificationInfo')">
                {{ $t('fields.notifyByEmail') }}:
              </label>
            </div>
            <div class="col-lg-4">
              <b-form-checkbox
                v-model="notifyByEmail"
                :value="true"
                :unchecked-value="false"
                v-b-tooltip.hover
                :title="$t('notifications.email.ReservationNotificationInfo')" />
            </div>
          </div>
          <div class="row my-3">
            <div class="col-lg-5">
              <label for="notifyBySms"
                     v-b-tooltip.hover
                     :title="$t('notifications.sms.NearBeforeReservationSmsNotificationInfo')">
                {{ $t('fields.notifyBySms') }}:
              </label>
            </div>
            <div class="col-lg-4">
              <b-form-checkbox
                v-model="notifyBySms"
                :value="true"
                :unchecked-value="false"
                v-b-tooltip.hover
                :title="$t('notifications.sms.NearBeforeReservationSmsNotificationInfo')" />
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="row my-3 p-2">
            <div class="row">
              <div class="col-lg-9">
                <label for="gender">{{ $t('common.DNAAgreement') }}:</label>
              </div>
              <div class="col-lg-9">
                <DNAAgreementDigitalInput
                  v-model="DNAAgreementDigital" />
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-lg-12">
                <b-form-group :label="$t('common.DNAAgreementDecision')+':'">
                  <b-form-radio-group v-model="DNASampleUsageStatus"
                                      name="DNAStatusRadio">
                    <b-form-radio
                      :value="1"
                      :disabled="DNASampleWasSet || DNAAgreementDigital">
                      {{ $t('DNAAgreement.1') }}
                    </b-form-radio>
                    <b-form-radio
                      :value="2"
                      :disabled="DNASampleWasSet || DNAAgreementDigital">
                      {{ $t('DNAAgreement.2') }}
                    </b-form-radio>
                    <b-form-radio
                      :value="3"
                      :disabled="DNASampleWasSet || DNAAgreementDigital">
                      {{ $t('DNAAgreement.3') }}
                    </b-form-radio>
                    <b-form-radio
                      :value="4"
                      :disabled="DNASampleWasSet || DNAAgreementDigital">
                      {{ $t('DNAAgreement.4') }}
                    </b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-lg-1">
                <b-form-checkbox
                  :disabled="DNASampleWasSet || DNAAgreementDigital"
                  v-model="agreedToSampleBeingUsedForScientificPurposes" />
              </div>
              <div class="col-lg-11">
                <label for="gender">{{ $t('fields.agreedToSampleBeingUsedForScientificPurposes') }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-2">
                <b-form-checkbox
                  :disabled="DNASampleWasSet || DNAAgreementDigital"
                  v-model="agreedToSampleExamination" />
              </div>
              <div class="col-lg-10">
                <label for="gender">{{ $t('fields.agreedToSampleExamination') }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="row col-4 offset-7">
          <b-button
            type="submit"
            class="myButton align-middle">
            {{ $t("common.Edit") }}
          </b-button>
        </div>
      </ValidationObserver>
    </div>

    <v-row v-show="ready">
      <v-col cols="12">
        <customer-relationship :customer-id="Number(id)">
        </customer-relationship>
      </v-col>
    </v-row>

  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import GenderInput from '@components/input/GenderInput';
import DNAAgreementDigitalInput from '@components/input/DNAAgreementDigitalInput';
import PhoneNumberInput from '@components/input/PhoneNumberInput';
import CustomerRelationship from "@components/admin/relationships/CustomerRelationship";

export default {
  name: 'CustomerEdit',
  components: {
    CustomerRelationship,
    GenderInput,
    DNAAgreementDigitalInput,
    PhoneNumberInput
  },
  data() {
    return {
      ready: false,
      DNASampleWasSet: false
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    ...mapState('editCustomer', [
      'extID',
      'agreedToDataProcessing',
      'agreedToTermsOfService']),
    name: {
      get() {
        return this.$store.state.editCustomer.name;
      },
      set(val) {
        this.setName(val);
      }
    },
    surname: {
      get() {
        return this.$store.state.editCustomer.surname;
      },
      set(val) {
        this.setSurname(val);
      }
    },
    phone: {
      get() {
        return this.$store.state.editCustomer.phone;
      },
      set(val) {
        this.setPhone(val);
      }
    },
    email: {
      get() {
        return this.$store.state.editCustomer.email;
      },
      set(val) {
        this.setEmail(val);
      }
    },
    gender: {
      get() {
        return this.$store.state.editCustomer.gender;
      },
      set(val) {
        this.setGender(val);
      }
    },
    street: {
      get() {
        return this.$store.state.editCustomer.street;
      },
      set(val) {
        this.setStreet(val);
      }
    },
    streetNumber: {
      get() {
        return this.$store.state.editCustomer.streetNumber;
      },
      set(val) {
        this.setStreetNumber(val);
      }
    },
    city: {
      get() {
        return this.$store.state.editCustomer.city;
      },
      set(val) {
        this.setCity(val);
      }
    },
    zipCode: {
      get() {
        return this.$store.state.editCustomer.zipCode;
      },
      set(val) {
        this.setZipCode(val);
      }
    },
    openLimsID: {
      get() {
        return this.$store.state.editCustomer.openLimsID;
      },
      set(val) {
        this.setOpenLimsID(val);
      }
    },
    DNAAgreementDigital: {
      get() {
        return this.$store.state.editCustomer.DNAAgreementDigital;
      },
      set(val) {
        this.setDNAAgreementDigital(val);
      }
    },
    DNASampleUsageStatus: {
      get() {
        return this.$store.state.editCustomer.DNASampleUsageStatus;
      },
      set(val) {
        this.setDNASampleUsageStatus(val);
      }
    },
    agreedToSampleBeingUsedForScientificPurposes: {
      get() {
        return this.$store.state.editCustomer.agreedToSampleBeingUsedForScientificPurposes;
      },
      set(val) {
        this.setAgreedToSampleBeingUsedForScientificPurposes(val);
      }
    },
    agreedToSampleExamination: {
      get() {
        return this.$store.state.editCustomer.agreedToSampleExamination;
      },
      set(val) {
        this.setAgreedToSampleExamination(val);
      }
    },
    registrationSource: {
      get() {
        return this.$store.state.editCustomer.registrationSource;
      }
    },
    notifyByEmail: {
      get() {
        return this.$store.state.editCustomer.notifyByEmail;
      },
      set(val) {
        this.setNotifyByEmail(val);
      }
    },
    notifyBySms: {
      get() {
        return this.$store.state.editCustomer.notifyBySms;
      },
      set(val) {
        this.setNotifyBySms(val);
      }
    },
    isOpenLimsIDEditable() {
      return (this.isLaborant || this.isAdministrator) && this.hasOpenLimsIDPermission;
    },
    isLaborant() {
      return this.role === 'Laboratory Scientist';
    },
    isAdministrator() {
      return this.role === 'Administrator';
    },
    role() {
      return this.$store.state['vue-auth']?.user.role || '';
    },
    hasOpenLimsIDPermission() {
      return this.$auth.check('Permissions.AdminPanel.Customers.OpenLimsID');
    }
  },
  created() {
    this.setCustomerId(this.id);
    this.fetchCustomer()
      .then(() => {
        this.ready = true;
        this.DNASampleWasSet = this.DNASampleUsageStatus !== 0;
      });
  },
  methods: {
    ...mapActions({
      fetchCustomer: 'editCustomer/fetchCustomer',
      resetContext: 'editCustomer/resetContext',
      editCustomer: 'editCustomer/editCustomer'
    }),
    ...mapMutations({ setCustomerId: 'editCustomer/setCustomerId',
      setName: 'editCustomer/setName',
      setSurname: 'editCustomer/setSurname',
      setPhone: 'editCustomer/setPhone',
      setEmail: 'editCustomer/setEmail',
      setGender: 'editCustomer/setGender',
      setStreet: 'editCustomer/setStreet',
      setStreetNumber: 'editCustomer/setStreetNumber',
      setCity: 'editCustomer/setCity',
      setZipCode: 'editCustomer/setZipCode',
      setOpenLimsID: 'editCustomer/setOpenLimsID',
      setDNAAgreementDigital: 'editCustomer/setDNAAgreementDigital',
      setAgreedToSampleBeingUsedForScientificPurposes: 'editCustomer/setAgreedToSampleBeingUsedForScientificPurposes',
      setAgreedToSampleExamination: 'editCustomer/setAgreedToSampleExamination',
      setDNASampleUsageStatus: 'editCustomer/setDNASampleUsageStatus',
      setNotifyByEmail: 'editCustomer/setNotifyByEmail',
      setNotifyBySms: 'editCustomer/setNotifyBySms' }),
    async submit() {
      let isValid = Boolean(this.phone.prefix);
      if (!isValid) {
        this.$refs.phoneInput.setErrors(['Zadejte platné telefonní číslo']);
        return;
      }
      // eslint-disable-next-line no-restricted-globals
      isValid = this.phone.number.length > 0 && !isNaN(this.phone.number);
      if (!isValid) {
        this.$refs.phoneInput.setErrors(['Zadejte platné telefonní číslo']);
        return;
      }
      isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.editCustomer()
          .then(() => {
            this.resetContext();
            this.$root.$bvToast.toast(this.$t('EditCustomer.SuccessToast.Body'), {
              title: this.$t('EditCustomer.SuccessToast.Title'),
              variant: 'success',
              toaster: 'b-toaster-top-right'
            });
            this.$router.replace({ name: 'admin.customers.view' });
          })
          .catch((res) => {
            var message = this.$t('EditCustomer.FailToast.Body');
            if (res.data.errors != null
              && res.data.errors.length > 0
              && res.data.errors[0].length !== 0) {
              message = res.data.errors[0];
            }
            this.$root.$bvToast.toast(message, {
              title: this.$t('EditCustomer.FailToast.Title'),
              variant: 'danger',
              toaster: 'b-toaster-top-right'
            });
          });
      }
    },
  }
};
</script>
<style lang="scss" scoped>
</style>
